import * as React from 'react'
import Select from 'react-select'
import { inject, observer } from 'mobx-react'
import { Supplier } from '@getgreenline/homi-shared'
import { CurrentCompanyStore } from '../../../stores/CurrentCompanyStore'
import { message, Modal } from 'antd'
import { Track } from '../../../Track'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  supplier: Supplier
  onClose: () => void
}

interface State {
  newSupplierId: number | null
  isDeleting: boolean
}

@inject('currentCompanyStore')
@observer
export class DeleteSupplierModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      newSupplierId: null,
      isDeleting: false,
    }
  }

  deleteSupplier = async () => {
    if (
      this.state.newSupplierId ||
      window.confirm(
        "Are you sure you want to delete without migrating vendors?\n Your current products and purchase orders won't have a vendor assigned.",
      )
    ) {
      this.setState({ isDeleting: true })

      try {
        await this.props.currentCompanyStore!.supplierStore!.deleteSupplier(
          this.props.supplier.id,
          {
            newSupplierId: this.state.newSupplierId,
          },
        )
        if (this.state.newSupplierId) {
          Track.track('dashboard:vendors_migrated', {
            originalId: this.props.supplier.id,
            newId: this.state.newSupplierId,
          })
        }
        Track.track('dashboard:vendors_deleted', { id: this.props.supplier.id })
        this.props.onClose()
        await this.props.currentCompanyStore!.supplierStore!.getSuppliers()
      } catch (err) {
        message.error(err)
      } finally {
        this.setState({ isDeleting: false })
      }
    }
  }

  render() {
    const { supplier } = this.props
    const suppliers = this.props.currentCompanyStore!.supplierStore!.suppliers || []
    const buttonStyle = this.state.newSupplierId ? 'btn-success' : 'btn-danger'

    return (
      <Modal visible={true} onCancel={this.props.onClose} title='Delete brand/vendor' footer={null}>
        <div className='d-flex'>
          <div className='fa fa-exclamation-triangle text-muted fa-4x mr-3 mt-4' />
          <div>
            <div>You are about to delete the {supplier.name} brand/vendor.</div>
            <small className='text-muted'>
              <div>
                Please select a brand/vendor to migrate all existing products and purchase orders to
              </div>
            </small>
            <br />
            <div>
              <Select
                value={this.state.newSupplierId}
                clearable={true}
                options={suppliers.map((supplier) => {
                  return {
                    label: supplier.name,
                    value: supplier.id,
                  }
                })}
                onChange={(option: { label: string; value: number }) => {
                  this.setState({
                    newSupplierId: option ? option.value : null,
                  })
                }}
              />
            </div>
          </div>
        </div>

        <br />

        <div>
          <button
            className={`btn btn-large w-100 ${buttonStyle}`}
            disabled={this.state.isDeleting}
            onClick={this.deleteSupplier}
          >
            {this.state.isDeleting
              ? 'Deleting...'
              : this.state.newSupplierId
              ? 'Delete and migrate'
              : 'Delete'}
          </button>
        </div>
      </Modal>
    )
  }
}
